import { useEffect, useState } from 'react';

import { SignatureCountry } from '../types';
import {
  checkCuitArgentina,
  checkNifSpain,
  checkNitColombia,
  checkRucParaguay,
  checkRucPeru,
  checkRutChile,
  checkTaxIdOtherCountries,
  formatCuitArgentina,
  formatNifSpain,
  formatNitColombia,
  formatRucParaguay,
  formatRucPeru,
  formatRutChile,
} from '../utils/rutUtils';

export function useTaxIdCompanies(initialTaxId: string) {
  const [value, setValue] = useState(initialTaxId);
  const [valid, setValid] = useState(true);
  const [country, setCountry] = useState('');

  const checkTaxId = (taxId: string) => {
    switch (country) {
      case 'CL':
        return checkRutChile(taxId);
      case 'PE':
        return checkRucPeru(taxId);
      case 'CO':
        return checkNitColombia(taxId);
      case 'AR':
        return checkCuitArgentina(taxId);
      case 'PY':
        return checkRucParaguay(taxId);
      case 'ES':
        return checkNifSpain(taxId);
      default:
        return checkTaxIdOtherCountries(country, taxId);
    }
  };

  const formatTaxId = (taxId: string) => {
    switch (country) {
      case 'CL':
        return formatRutChile(taxId);
      case 'PE':
        return formatRucPeru(taxId);
      case 'CO':
        return formatNitColombia(taxId);
      case 'AR':
        return formatCuitArgentina(taxId);
      case 'PY':
        return formatRucParaguay(taxId);
      case 'ES':
        return formatNifSpain(taxId);
      default:
        return taxId;
    }
  };

  useEffect(() => {
    if (value !== '') {
      setTaxId(value);
    }
  }, [country]);

  const setTaxId = (taxId: string) => {
    const formattedTaxId = formatTaxId(taxId);
    setValue(formattedTaxId);
    setValid(checkTaxId(formattedTaxId));
  };

  return {
    taxId: { value, valid, country: country as SignatureCountry },
    setTaxId,
    setCountry,
  };
}
